import { castIdRouteParams } from '../helpers/helpers'

export default [
    {
        path: '/tariffGroups',
        name: 'tariffGroups',
        component: () => import('../views/finance/TariffGroups.vue'),
        meta: { claims: [{ name: 'tariff', crud: 'read' }] }
    },
    {
        path: '/tariff/create',
        name: 'createTariffEntity',
        component: () => import('../views/finance/Tariff.vue'),
        meta: { claims: [{ name: 'tariff', crud: 'create' }] }
    },
    {
        path: '/tariff/edit/:id',
        name: 'editTariffEntity',
        component: () => import('../views/finance/Tariff.vue'),
        meta: { claims: [{ name: 'tariff', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/tariff/copy/:id',
        name: 'copyTariff',
        component: () => import('../views/finance/Tariff.vue'),
        meta: { claims: [{ name: 'tariff', crud: 'create' }] },
        props: (route) => ({ id: Number(route.params.id), isCopy: true })
    },
]
